import React, {useEffect} from "react";
import {animated, useSpring} from "@react-spring/web";

interface Props {
    size?: number,
    color?: string,
    direction?: 'right' | 'bottom' | 'left',
}

const rotationAngles: Record<string, string> = {
    right: '0deg',
    bottom: '90deg',
    left: '180deg',
}

const SvgChevron = ({
    size = 8,
    color = '#2C2C2C',
    direction = 'right',
}: Props) => {

    const [animationStyle, api] = useSpring(() => ({
        from: {
            rotate: `${rotationAngles?.[direction]}` ?? '0deg',
        },
        display: 'flex',
    }));

    useEffect(() => {
        api.start({
            to: {
                rotate: `${rotationAngles?.[direction]}` ?? '0deg',
            }
        })
    }, [direction]);

    return (
        <animated.div
            style={animationStyle}
        >
            <svg
                width={size}
                height={size * 14 / 8}
                viewBox="0 0 8 14"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M1 13L7 7L1 1"
                    stroke={color}
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        </animated.div>
    );
}

export default SvgChevron;